import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import type { Profile } from '@/lib/api';
import { updateProfile } from '@/server/profile.functions';

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: (data: Partial<Profile>) =>
      updateProfile({
        data: data as Parameters<typeof updateProfile>[0]['data'],
      }),
    onError: (error: Error) => push(error.message || 'Save failed', 'error'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
};
